import { useAtomValue } from 'jotai';

import { Stack } from '@ekhodealer/ekho-common/rev';

import { AccordionSection } from '@common/components/AccordionSection';
import { InfoLineItem } from '@common/components/InfoLineItem';

import { useGetPreorderDetails } from '../../api/useGetPreorderDetails';
import { preorderDetailsDrawerAtom } from '../../atoms/preorderDetailsDrawerAtoms';

const SECTION_TITLE = 'Buyer details';

export const BuyerDetailsSection = (): React.ReactNode => {
	const { preorderId } = useAtomValue(preorderDetailsDrawerAtom);
	const { data: preorderDetails, isLoading } = useGetPreorderDetails(
		preorderId ?? undefined,
	);

	if (isLoading) {
		return (
			<AccordionSection title={SECTION_TITLE} defaultExpanded>
				<Stack itemsSpacing='16'>
					<InfoLineItem title='Buyer name' isLoading />
					<InfoLineItem title='Buyer ID' isLoading />
					<InfoLineItem title='Email' isLoading />
					<InfoLineItem title='Phone' isLoading />
					<InfoLineItem title='Address' isLoading />
				</Stack>
			</AccordionSection>
		);
	}

	if (!preorderDetails) {
		return null;
	}

	const { buyerDetails } = preorderDetails;

	return (
		<AccordionSection title={SECTION_TITLE} defaultExpanded>
			<Stack itemsSpacing='16'>
				<InfoLineItem title='Buyer name' value={buyerDetails.fullName} isCopyable />
				<InfoLineItem title='Buyer ID' value={buyerDetails.buyerId} isCopyable />
				{buyerDetails.email && (
					<InfoLineItem title='Email' value={buyerDetails.email} isCopyable />
				)}
				{buyerDetails.phone && (
					<InfoLineItem title='Phone' value={buyerDetails.phone} isCopyable />
				)}
				{buyerDetails.addressString && (
					<InfoLineItem title='Address' value={buyerDetails.addressString} isCopyable />
				)}
				{buyerDetails.state && (
					<InfoLineItem title='State' value={buyerDetails.state} />
				)}
			</Stack>
		</AccordionSection>
	);
};
